import { TableRowWithId } from "./table-interfaces";

export declare type SortDirection = "" | "asc" | "desc";
export declare interface SortData {
    sortProperty: string;
    direction: SortDirection;
    customComparator?: (<T>(a: T, b: T) => number) | undefined;
}

export declare interface FilterCriterion {
    field: string;
    selectedItems: [];
    customFilterCallback?: (filteredData: TableRowWithId[], items: []) => TableRowWithId[];
}
